import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import InfoBarMessage from './InfoBarMessage';
var InfoBar = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBar, _super);
    function InfoBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoBar.prototype.render = function () {
        var _this = this;
        // VSO 1777: add collapse/expand behavior to info bar
        // VSO 1778: sort info messages in info bar based on ranks
        return this.props.messages.length > 0 ? (React.createElement("div", { className: this.props.className }, this.props.messages.map(function (message) { return (React.createElement(InfoBarMessage, tslib_1.__assign({ key: message.key, textContainerClassName: _this.props.textContainerClassName }, message))); }))) : null;
    };
    InfoBar = tslib_1.__decorate([
        observer
    ], InfoBar);
    return InfoBar;
}(React.Component));
export default InfoBar;
//# sourceMappingURL=InfoBar.js.map